import isPlainObject from 'lodash.isplainobject';

import { localStorageService } from '@wf/sw-ui-kit';

import { UTC_REGEXP } from '../../../../../constants/regex';

export function getColumnSettings(tableName: string) {
  const settings = localStorageService.get(tableName);

  if (Array.isArray(settings)) {
    return settings;
  } else {
    localStorageService.remove(tableName);
  }
}

export function getRestrictionsFromLocalStorage(key: string) {
  const restrictions = localStorageService.get(key, (_, value) => {
    if (UTC_REGEXP.test(value as string)) {
      return new Date(value as string);
    }

    return value;
  });

  if (isPlainObject(restrictions)) {
    return restrictions;
  } else {
    localStorageService.remove(key);
  }
}

export function getShowFiltersFromLocalStorage(key: string) {
  const showFilters = localStorageService.get(key);

  if (typeof showFilters === 'boolean') {
    return showFilters;
  } else {
    localStorageService.remove(key);
  }
}
